module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAARCAYAAADkIz3lAAAAb0lEQVQoke3OMQqDYBCE0afkRDmGTcAuQjrb4BlyJa9gmdIr5ASS2IlpVlD5C8sUGRiY3f1YJns/6tkB5UegP/gjYBve6LSbn7hG7nBOfXyhxBi+xG4DDijWh8gFPgs44YY+0bdHhSnHPVV+pRbNF+VrFajVWqMZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alarm/detail-icon.png
// module id = p+hI
// module chunks = 1